import type { BbEventName } from './events'

/**
 * Fire-and-forget client-side event tracker.
 *
 * Rules:
 * - Never awaited — analytics must never block UI or throw.
 * - Never call during SSR (typeof fetch check guards it).
 * - POST /api/analytics/event attaches org/user context server-side.
 * - Also pushes to PostHog if initialised (session replay + funnel analysis).
 */
export function trackEvent(
  event: BbEventName,
  properties: Record<string, unknown> = {},
): void {
  if (typeof window === 'undefined') return
  try {
    // Custom Supabase table — org/user context attached server-side
    fetch('/api/analytics/event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event_name: event, properties }),
    }).catch(() => {})

    // PostHog — session replay + funnel analysis
    import('posthog-js').then(({ default: posthog }) => {
      try {
        if (posthog.__loaded) posthog.capture(event, properties)
      } catch {}
    }).catch(() => {})
  } catch {
    // swallow all sync errors
  }
}
